.modalBg {
	background-color: rgb(16, 16, 20, 0.45);
	backdrop-filter: blur(10px);
}

.modalCard {
	background-color: rgba(0, 0, 0, 0.45);
	backdrop-filter: blur(32px);
	border-radius: 12px;
	width: 100%;
	max-width: 270px;
	margin: 0 1rem;
	padding: 0;

	@media screen and (min-width: 768px) {
		max-width: 390px;
	}
}

.modalContent {
	padding: 2rem 1.25rem;
}

.modalClose {
	height: 55px;
	max-height: 55px;
	max-width: 55px;
	min-height: 55px;
	min-width: 55px;
	width: 55px;
	background: none;
	position: fixed;
	right: 0;
	top: 0;
}
